(() => {
  if (window.biancoSuePriceSavings) return;
  window.biancoSuePriceSavings = true;

  document.addEventListener('theme:variant:change', (event) => {
    const variant = event.detail && event.detail.variant;
    const productRoot = event.target.closest('[data-product]') || event.target;

    if (!variant || !productRoot || !productRoot.querySelectorAll) return;

    productRoot.querySelectorAll('[data-price-savings]').forEach((savingsElement) => {
      const priceWrapper = savingsElement.closest('[data-price-wrapper]');
      const variantsElement = priceWrapper && priceWrapper.querySelector('[data-price-savings-variants]');
      const amountElement = savingsElement.querySelector('[data-price-savings-amount]');

      if (!variantsElement || !amountElement) return;

      try {
        const savingsByVariant = JSON.parse(variantsElement.textContent);
        const savings = savingsByVariant[String(variant.id)];

        if (savings) {
          amountElement.textContent = savings;
          savingsElement.classList.remove('hidden');
        } else {
          amountElement.textContent = '';
          savingsElement.classList.add('hidden');
        }
      } catch (error) {
        savingsElement.classList.add('hidden');
      }
    });

    productRoot.querySelectorAll('[data-atc-price-summary]').forEach((summaryElement) => {
      const variantsElement = productRoot.querySelector('[data-atc-price-variants]');
      const currentPriceElement = summaryElement.querySelector('[data-atc-current-price]');
      const comparePriceElement = summaryElement.querySelector('[data-atc-compare-price]');
      const saveElement = summaryElement.querySelector('[data-atc-save]');
      const saveAmountElement = summaryElement.querySelector('[data-atc-save-amount]');

      if (!variantsElement || !currentPriceElement || !comparePriceElement || !saveElement || !saveAmountElement) return;

      try {
        const pricesByVariant = JSON.parse(variantsElement.textContent);
        const prices = pricesByVariant[String(variant.id)];

        if (!prices || !prices.available) {
          summaryElement.classList.add('hidden');
          return;
        }

        currentPriceElement.textContent = prices.price;
        summaryElement.classList.remove('hidden');

        if (prices.comparePrice && prices.savings) {
          comparePriceElement.textContent = prices.comparePrice;
          saveAmountElement.textContent = prices.savings;
          comparePriceElement.classList.remove('hidden');
          saveElement.classList.remove('hidden');
        } else {
          comparePriceElement.textContent = '';
          saveAmountElement.textContent = '';
          comparePriceElement.classList.add('hidden');
          saveElement.classList.add('hidden');
        }
      } catch (error) {
        summaryElement.classList.add('hidden');
      }
    });
  });
})();
